import React, { useState } from "react"
import {
  Button as MaterialButton,
  ButtonGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core'
import {
  List,
  Datagrid,
  DateField,
  Pagination,
  TextField,
  FunctionField,
  Button,
  useNotify,
  useRefresh
} from 'react-admin'
import VisibilityIcon from '@material-ui/icons/Visibility'
import { Link } from 'react-router-dom'
import { BASE_URL, retryIntegration, closeIntegration } from '../../../providers/dataProvider'
import { StatusFieldCell } from '../StatusField'
import DefaultFiltersAndActions from "../DefaultFiltersAndActions"

const DefaultPagination = (props) => {
  if (typeof props.total === 'undefined') {
    return null
  }

  return (
    <Pagination rowsPerPageOptions={[25, 50, 100]} {...props} />
  )
}

const ActionsButton = ({ record = {} }) => {
  const notify = useNotify()
  const refresh = useRefresh()
  const [open, setOpen] = useState(false)

  if (record.status !== 'Failed' || !record.resourceitemid) {
    return null
  }

  const retry = () => {
    retryIntegration('docuclass', 'preinvoice', record.resourceitemid)
      .then(success => {
        if (success) {
          notify(
            'La pre-factura se ha vuelto a procesar. Espera unos segundos a que termine y recarga para ver los resultados.',
            'info',
            null,
            false,
            3000
          )
        }
        else {
          notify(
            'No ha sido posible volver a procesar la pre-factura. Intentalo nuevamente.',
            'warning',
            null,
            false,
            3000
          )
        }
      })
  }

  const close = () => {
    setOpen(false)

    closeIntegration('docuclass', 'preinvoice', record.resourceitemid)
      .then(success => {
        if (success) {
          notify(
            'La pre-factura ha sido cerrada.',
            'info',
            null,
            false,
            3000
          )
          refresh()
        }
        else {
          notify(
            'No ha sido posible cerrar la pre-factura. Intentalo nuevamente.',
            'warning',
            null,
            false,
            3000
          )
        }
      })
  }

  return (
    <React.Fragment>
      <ButtonGroup color="primary" size="small">
        <MaterialButton onClick={() => setOpen(true)}>
          Cerrar
        </MaterialButton>

        <MaterialButton onClick={retry}>
          Reproceso
        </MaterialButton>
      </ButtonGroup>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
      >
        <DialogTitle>Cerrar pre-factura</DialogTitle>

        <DialogContent>
          <DialogContentText>
            Deseas cerrar esta pre-factura? No podras revertir el cambio.
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <MaterialButton
            onClick={() => setOpen(false)}
            color="primary"
          >
            NO
          </MaterialButton>

          <MaterialButton
            onClick={close}
            color="primary"
          >
            SI
          </MaterialButton>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}
const IntegrationResultList = (props) => {
  const {
    staticContext,
    ...listProps
  } = props

  return (
    <List
      perPage={25}
      title="Registro de pre-facturas"
      bulkActionButtons={false}
      pagination={<DefaultPagination />}
      exporter={false}
      basePath={BASE_URL}
      resource="zicsa/preinvoices"
      sort={{ field: 'createdat', order: 'DESC' }}
      actions={<DefaultFiltersAndActions resourceName="preinvoices" />}
      {...listProps}
    >
      <Datagrid stickyHeader>
        <TextField source="numero_factura" label="N° Factura" emptyText="-" sortable />
        <TextField source="numero_orden_compra" label="N° Orden de Compra" emptyText="-" sortable />
        <TextField source="fecha_factura" label="Fecha Factura" emptyText="-" sortable />
        <StatusFieldCell label="Estado" source="status" sortable />
        <FunctionField
          label="Error"
          render={record => record && record.error ? <span style={{ display: 'block', maxWidth: 380 }}>{record.error}</span> : '-'}
        />
        <DateField source="createdat" label="Fecha Envio" showTime locales="es-CL" sortable />
        <DateField source="updatedat" label="Ultima Actualizacion" showTime locales="es-CL" sortable emptyText="-" />

        <FunctionField
          label=""
          render={record => {
            const id = record && (record.id || record.integration_result_id || record.resourceitemid)

            if (!id) {
              return null
            }

            return (
              <Button
                component={Link}
                to={`/zicsa/preinvoices/${id}/show`}
                label="Detalle"
              >
                <VisibilityIcon />
              </Button>
            )
          }}
        />
        <ActionsButton />
      </Datagrid>
    </List>
  )
}

export default IntegrationResultList